<template>
    <el-form @submit.prevent>
        <el-form-item label="Suodata">
            <div class="el-input el-input--small">
                <div class="el-input__wrapper">
                    <input 
                    class="el-input__inner" 
                    :value="modelValue" 
                    @input="filterChange"
                    @keyup.enter="filterNow"/>
                </div>
            </div>
        </el-form-item>
    </el-form>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
    props: {
        modelValue: {
            type: String,
            required: true,
        },
    },
    emits: ["update:modelValue"],
    setup(props, { emit }) {
        let timetOut = NaN

        const filterChange = (event: Event) => {
            clearTimeout(timetOut)
            timetOut = window.setTimeout(() => {
                filterNow(event)
            }, 1000)
        }

        const filterNow = (event: Event) => {
            const target = event.target as HTMLInputElement

            clearTimeout(timetOut)
            emit("update:modelValue", target.value)
        }

        return { filterChange, filterNow }
    },
})
</script>
